import React from "react";

import { useTheme } from "../../../utils/Theme";

import { SVGProps } from "./SVG.props";

const ClearInactive = (props: SVGProps): JSX.Element => {
  const theme = useTheme();
  const { width, height, fill } = props;

  // Paste converted svg below
  // https://react-svgr.com/playground/?typescript=true
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 30}
      height={height || 30}
      fill="none"
      viewBox="0 0 185 181"
    >
      <g filter="url(#filter0_i_2496_19203)">
        <path
          fill="#C5E5F7"
          d="M152.658 90.81c0 32.257-26.796 58.407-59.85 58.407-33.055 0-59.851-26.15-59.851-58.407 0-32.258 26.796-58.408 59.85-58.408 33.055 0 59.851 26.15 59.851 58.408z"
        ></path>
      </g>
      <path
        fill="#C5E5F7"
        fillRule="evenodd"
        d="M92.344 0h.106c5.523.003 9.997 4.483 9.994 10.005-.003 5.523-4.482 9.998-10.005 9.995h-.084c-5.523.003-10.003-4.472-10.006-9.995C82.346 4.483 86.821.003 92.344 0zm32.106 15.662c2.688-4.825 8.778-6.558 13.603-3.87l.093.052c4.821 2.693 6.547 8.785 3.853 13.607-2.693 4.821-8.785 6.547-13.607 3.854l-.072-.041c-4.825-2.688-6.557-8.778-3.87-13.602zm-64.107 0c2.688 4.824.956 10.914-3.869 13.602l-.073.04c-4.821 2.694-10.913.968-13.607-3.853-2.693-4.822-.967-10.914 3.854-13.607l.093-.052c4.825-2.688 10.915-.955 13.602 3.87zm98.028 25.555c4.733-2.845 10.877-1.313 13.722 3.42l.055.091c2.839 4.738 1.301 10.88-3.436 13.719-4.737 2.84-10.879 1.3-13.719-3.436l-.042-.071c-2.845-4.734-1.314-10.878 3.42-13.723zm-131.948 0c4.734 2.845 6.265 8.99 3.42 13.723l-.043.07c-2.839 4.738-8.98 6.276-13.718 3.437-4.737-2.84-6.275-8.981-3.436-13.719l.055-.09c2.845-4.734 8.988-6.266 13.722-3.42zM10.006 80.363c5.523.003 9.997 4.483 9.994 10.006v.083c.003 5.523-4.471 10.003-9.994 10.006C4.483 100.461.003 95.987 0 90.464v-.107c.003-5.523 4.483-9.998 10.006-9.994zm164.782 0c5.523-.004 10.003 4.471 10.006 9.994v.107c-.003 5.523-4.483 9.997-10.006 9.994-5.523-.003-9.997-4.483-9.994-10.006v-.083c-.003-5.523 4.471-10.003 9.994-10.006zM16.082 122.374c4.737-2.84 10.88-1.301 13.718 3.436l.043.071c2.845 4.733 1.314 10.877-3.42 13.722-4.734 2.845-10.877 1.314-13.722-3.42l-.055-.091c-2.84-4.737-1.3-10.879 3.436-13.718zm152.63 0c4.737 2.839 6.275 8.981 3.436 13.718l-.055.091c-2.845 4.734-8.989 6.265-13.722 3.42-4.734-2.845-6.265-8.989-3.42-13.722l.042-.071c2.84-4.737 8.982-6.276 13.719-3.436zM42.795 155.37c2.693-4.822 8.785-6.547 13.606-3.854l.073.041c4.825 2.687 6.557 8.777 3.87 13.602-2.688 4.825-8.779 6.557-13.603 3.869l-.093-.051c-4.821-2.694-6.547-8.786-3.854-13.607zm99.204 0c2.694 4.821.968 10.913-3.853 13.607l-.093.051c-4.825 2.688-10.915.956-13.603-3.869-2.687-4.825-.955-10.915 3.87-13.602l.072-.041c4.822-2.693 10.914-.968 13.607 3.854zm-59.65 15.445c.003-5.523 4.483-9.998 10.006-9.994h.084c5.523-.004 10.002 4.471 10.005 9.994.003 5.523-4.471 10.002-9.994 10.006h-.106c-5.523-.004-9.998-4.483-9.995-10.006z"
        clipRule="evenodd"
      ></path>
      <defs>
        <filter
          id="filter0_i_2496_19203"
          width="129.701"
          height="129.814"
          x="22.957"
          y="32.402"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="-10" dy="13"></feOffset>
          <feGaussianBlur stdDeviation="12"></feGaussianBlur>
          <feComposite
            in2="hardAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
          ></feComposite>
          <feColorMatrix values="0 0 0 0 0.772549 0 0 0 0 0.898039 0 0 0 0 0.968627 0 0 0 0.9 0"></feColorMatrix>
          <feBlend
            in2="shape"
            result="effect1_innerShadow_2496_19203"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default ClearInactive;
